import { oauthService } from "../services/oauth.service";

export async function startOAuthPopup({ provider, flow, title, signupData }) {
  const data = await oauthService.start({ provider, flow, ...signupData });

  const authUrl = data?.authorization_url;
  if (!authUrl) {
    throw new Error("No authorization_url returned");
  }

  const w = 520;
  const h = 650;
  const left = window.screenX + (window.outerWidth - w) / 2;
  const top = window.screenY + (window.outerHeight - h) / 2;

  const popup = window.open(
    authUrl,
    title || `OAuth ${provider}`,
    `width=${w},height=${h},left=${left},top=${top},resizable=yes,scrollbars=yes`,
  );

  if (!popup) {
    throw new Error("Popup bloqueado por el navegador");
  }

  try {
    popup.focus();
  } catch { }

  return popup;
}
